// eslint-disable-next-line import/prefer-default-export
export const finderFilters = {
  brandFilter: $('select#id_brand[name="brand"]'),
  modelFilter: $('select#id_model[name="model"]'),
  productionPeriodFilter: $('select#id_production_period[name="production_period"]'),
  removableBallFilter: $('input#id_removable_ball[name="removable_ball"]'),
};

export const disableFilterInputs = () => {
  // TODO: fix disabling when selecting filters
  Object.values(finderFilters).forEach(($filter) => {
    if (!$filter.val()) {
      const $siblings = $filter.parent().nextAll();
      $siblings.each((index, el) => {
        $(el).find(':input').prop('disabled', true);
      });
    }
  });
};
disableFilterInputs();
